<div class="round-container-center">
  <div roundNames>
    @if ({ round: round.current | async }; as $current) {
      @for ($round of round.names; track $round; let $i = $index) {
        <div roundName (click)="round.setCurrent($i)">
          <span class="unselected">{{$round}}</span>
          <span class="selected">{{$round}}</span>
        </div>
      }
    }
  </div>

  @if (DEBUG) {
    <!-- DISPLAY RECTANGLES FOR DEBUGGING SIZE CALCULATIONS -->
    <div class="position-absolute d-flex-row top-0 start-0 h-100">
      @for (data of nameData; track data) {
        <div
          class="border border-danger border-1 position-absolute h-100 top-0"
          [style.left]="pixels(data.selected.offset)"
          [style.width]="pixels(data.selected.width)"
        ></div>
      }
    </div>
    <div class="position-absolute d-flex-row top-0 start-0 h-100">
      @for (data of nameData; track data) {
        <div
          class="border border-success border-1 position-absolute h-100 top-0"
          [style.left]="pixels(data.unselected.offset)"
          [style.width]="pixels(data.unselected.width)"
        ></div>
      }
    </div>
  }
</div>
